import { AllInsuranceResponse, InsuranceResponse } from '@gtpl/shared-models/sale-management';
import { Injectable } from '@nestjs/common';
import { InsuranceAdapater } from './adapters/insurance-adapter';

import { InsuranceDto } from './dto/insurance-dto';
import { InsuranceRepository } from './insurance-repository';
import { InsuranceEntity } from './insurance.entity';
import { SaleorderService } from './saleorder.service';

@Injectable()
export class InsuranceService {

    constructor(private repository: InsuranceRepository, private adapter: InsuranceAdapater, private soService:SaleorderService) {

    }

    async CreateInsurance(details: InsuranceDto):Promise<InsuranceResponse> {
        const convertedEntity = await this.adapter.convertDtoToEntity(details);
        const response = await this.repository.save(convertedEntity);
        if(response){
            return new InsuranceResponse(true, 1111, 'Created Successfully');
        }else{
            return new InsuranceResponse(false, 9999, 'Failed To Create');
        }

    }

    async getAllFiles(): Promise<AllInsuranceResponse> {
        const fileInfo: InsuranceEntity[] = await this.repository.find();
        console.log(fileInfo);
        if (fileInfo.length) {
            const insurenceFDto: InsuranceDto[] = []
            for (const files of fileInfo) {
                const insDto = new InsuranceDto();
                insDto.fileName = files.fileName;
                insDto.filePath = files.filePath;
                insDto.originalname = files.originalname;
                insDto.destination = files.destination;
                insDto.saleOrderId = files.saleOrderId;
                insDto.saleOrderName = (await this.soService.getSaleOrderDataForSoId(files.saleOrderId)).saleOrderNumber;
                insurenceFDto.push(insDto)
            }
            

            return new AllInsuranceResponse(true, 1111, 'Uploaded File Information Retrieved Successfully', insurenceFDto)
        } else {
            return new AllInsuranceResponse(false, 1111, 'Failed To Retrieve Uploaded Files Info')
        }

    }


}



